<!-- Infokasti komponent -->
<template>
  <div class="main-quote">
    <div class="d-flex quote pa-5">
      <div class="logo">
        <svg width="64px" height="64px" viewBox="-102.4 -102.4 1228.80 1228.80" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"><path transform="translate(-102.4, -102.4), scale(38.4)" d="M16,29.11040457231658C18.55556989032872,29.21914982573669,21.446876479448765,30.53074674922516,23.54277105363352,29.06446269475309C25.665386635032164,27.579484671948958,25.214992362606008,24.294916100237685,26.2669802047675,21.927643784987076C27.18699633966758,19.857345404676987,29.17523389895789,18.25888389313223,29.348463888679234,16C29.525257198707255,13.694651133569712,28.125331019505328,11.64989518655444,27.218261110138002,9.523133928222318C26.195893412391143,7.126039736381255,25.70024239511623,4.345461077929588,23.677157597350227,2.7027729836760077C21.56820688808126,0.990364178415202,18.71323203976617,0.2786149456993401,16.000000000000004,0.4142206566674371C13.339198702274825,0.5472059105766299,10.785264343266075,1.7254611608814008,8.753474535686633,3.448649717467589C6.879262870796176,5.038194109073318,5.946193862137192,7.392817977424084,5.0661701482341694,9.687350391809424C4.287486399465378,11.717653750545933,4.129154692020808,13.833766744122489,3.939645878970623,15.999999999999998C3.7332332199295064,18.35945737431516,3.0379573455178015,20.779375677094528,3.902915643883963,22.984254909413192C4.812208846141825,25.30214896457627,6.5976799463614,27.313042352182375,8.818957042481212,28.437931253757203C11.000940097916544,29.542921048488846,13.556387835458093,29.006423372233105,16,29.11040457231658" opacity="80%" fill="#3b71f7" strokewidth="0"></path></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#000000" d="M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64zm67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344zM590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"></path></g></svg>
      </div>
      <div><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleQuote"
}
</script>

<style scoped>
.quote {
  background: #eeeeee;
  text-align: left;
  justify-content: left;
  align-items: center;
  border-radius: 8px;
}

.main-quote {
  padding: 0;

}

.logo {
  padding-right: 20px;
}

@media (max-width: 650px) {
  .quote {
    flex-direction: column;
  }
  .main-quote {
    padding-bottom: 40px;
  }
  .logo {
    padding-right: 0;
  }
}

</style>